import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models'

export class InjuryApiService extends ApiService {
  static async createInjury(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('injuries', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async updateInjury(injuryId: number, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`injuries/${injuryId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchInjuryTypes(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('injury-types', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchInjuryBodyParts(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('injury-body-parts', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchInjurySurfaces(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('injury-surfaces', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchInjuries(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('injuries', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchInjury(injuryId: number): Promise<IServiceResponse<object>> {
    return this.axios.get(`injuries/${injuryId}`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async startNextPhase(injuryId: number, data: object): Promise<IServiceResponse<object>> {
    return this.axios.post(`injuries/${injuryId}/next-phase`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async editPhase(injuryPhaseId: number, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`injury-phases/${injuryPhaseId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async storeExpectedReturnDate(injuryId: number, data: object): Promise<IServiceResponse<object>> {
    return this.axios.post(`injuries/${injuryId}/expected-return`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async submitNote(injuryPhaseId: number, data: object): Promise<object> {
    return this.axios.post(`injury-phases/${injuryPhaseId}/note`, data)
      .then(response => response.data)
  }

  static async deleteNote(injuryPhaseId: number, injuryNoteId: number): Promise<AxiosResponse> {
    return this.axios.delete(`injury-phases/${injuryPhaseId}/note/${injuryNoteId}`).then(response => response.data)
  }

  static async deleteInjury(injuryId: number): Promise<AxiosResponse> {
    return this.axios.delete(`injuries/${injuryId}`).then(response => response.data)
  }

  static async fetchTeamStats(teamId: number, query: object): Promise<AxiosResponse> {
    return this.axios.get(`teams/${teamId}/injury-stats`, { params: query }).then(response => response.data)
  }

  static async fetchPlayersWithInjuries(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('players/injuries', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchPlayerStats(playerId: number, query: object): Promise<AxiosResponse> {
    return this.axios.get(`players/${playerId}/injury-stats`, { params: query }).then(response => response.data)
  }

  static async getPdfReport(injuryId: number): Promise<{ url: string }> {
    return this.axios.get(`injuries/${injuryId}/pdf`)
      .then((response: AxiosResponse<{ url: string }>) => response.data)
  }
}
